// Wave 1's 1:1 constraint (ContainerApp <-> at most one live Pipeline) is enforced
// server-side by a filtered-unique index; the FE mirrors it client-side so the wizard's
// target step (AC-6) and the Edit dialog's target dropdown (AC-19/TC-DPW-033) never even
// offer an already-piped container. Derived by flattening the grouped list (RV-2) rather
// than a dedicated endpoint (none exists).
//
// `excludePipelineId` lets the Edit dialog keep a pipeline's OWN current container
// selectable (editing shouldn't lock you out of your own target).
export const getPipedContainerAppIds = (groupedList = [], excludePipelineId) => {
  const piped = new Set();

  (groupedList ?? []).forEach((group) => {
    (group?.Pipelines ?? []).forEach((pipeline) => {
      if (excludePipelineId && pipeline.Id === excludePipelineId) {
        return;
      }
      if (pipeline?.ContainerAppId !== undefined && pipeline?.ContainerAppId !== null) {
        piped.add(pipeline.ContainerAppId);
      }
    });
  });

  return piped;
};

export default getPipedContainerAppIds;
